export const PLAN_CHANGE_EVENTS = {
  OptionsLoaded: 'plan change options loaded',
  TargetSelected: 'plan change target selected',
  ConfirmViewed: 'plan change confirm viewed',
  Submitted: 'plan change submitted',
  Failed: 'plan change failed',
  PendingCancelled: 'plan change pending cancelled',
  PromoCodeEntered: 'plan change promo code entered',
  PromoCodeAccepted: 'plan change promo code accepted',
  PromoCodeRejected: 'plan change promo code rejected',
} as const

export type PromoSource = 'automatic' | 'typed' | 'none'
